export enum ContractsTaxiForwardingContractListRequestOrder {
  PRIORITY_ASC = "PRIORITY_ASC",
  PRIORITY_DESC = "PRIORITY_DESC",
  DISPLAY_NAME_ASC = "DISPLAY_NAME_ASC",
  DISPLAY_NAME_DESC = "DISPLAY_NAME_DESC",
  PRODUCER_DISPLAY_NAME_ASC = "PRODUCER_DISPLAY_NAME_ASC",
  PRODUCER_DISPLAY_NAME_DESC = "PRODUCER_DISPLAY_NAME_DESC",
  CONSUMER_DISPLAY_NAME_ASC = "CONSUMER_DISPLAY_NAME_ASC",
  CONSUMER_DISPLAY_NAME_DESC = "CONSUMER_DISPLAY_NAME_DESC",
  HALTING_TIME_RATE_ASC = "HALTING_TIME_RATE_ASC",
  HALTING_TIME_RATE_DESC = "HALTING_TIME_RATE_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  HALTING_TIME_AFTER_MINUTES_ASC = "HALTING_TIME_AFTER_MINUTES_ASC",
  HALTING_TIME_AFTER_MINUTES_DESC = "HALTING_TIME_AFTER_MINUTES_DESC",
}

export enum ContractsTaxiForwardingContractListRequestModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsTaxiForwardingContractListRequestQueryParams = {
  displayName?: string;
  producerDisplayName?: string;
  consumerDisplayName?: string;
  engagedTaxiId?: string;
  model?: ContractsTaxiForwardingContractListRequestModel;
  resultsOrdering?: ContractsTaxiForwardingContractListRequestOrder;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  producerTaxiId?: string;
  startValidSince?: Date;
  endValidTo?: Date;
  startDistanceRate?: number;
  endDistanceRate?: number;
  startHaltingTimeAfterMinutes?: number;
  endHaltingTimeAfterMinutes?: number;
  startHaltingTimeRate?: number;
  endHaltingTimeRate?: number;
  isPartner?: boolean;
  isValid?: boolean;
  priority?: number;
  disabled?: boolean;
};

type ContractsTaxiForwardingContractListRequest = {
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  displayName?: string;
  producerDisplayName?: string;
  consumerDisplayName?: string;
  engagedTaxiId?: string;
  producerTaxiId?: string;
  startValidSince?: Date;
  endValidTo?: Date;
  startDistanceRate?: number;
  endDistanceRate?: number;
  startHaltingTimeAfterMinutes?: number;
  endHaltingTimeAfterMinutes?: number;
  startHaltingTimeRate?: number;
  endHaltingTimeRate?: number;
  isPartner?: boolean;
  isValid?: boolean;
  disabled?: boolean;
  priority?: number;
  model?: ContractsTaxiForwardingContractListRequestModel;
  resultsOrdering?: ContractsTaxiForwardingContractListRequestOrder;
};

export default ContractsTaxiForwardingContractListRequest;
